import { MutationTree } from 'vuex';
import IHomeState from './types/IHomeState';
import IHomeMeta from './types/IHomeMeta';
import { IHomeSlider } from './types/IHomeSlider';
import { IHomeStatistics } from './types/IHomeStatistics';
import { IHomeCovid19 } from './types/IHomeCovid19';

const mutations: MutationTree<IHomeState> = {
  setMeta(state, meta: IHomeMeta) {
    state.meta = meta;
  },

  setSlider(state, slider: IHomeSlider) {
    state.slider = slider;
  },

  setStatistics(state, statistics: IHomeStatistics) {
    state.statistics = statistics;
  },

  setCovid19(state, covid19: IHomeCovid19) {
    state.covid19 = covid19;
  },
};

export default mutations;
